import type { KeyboardEvent } from 'react';

/**
 * Props for an `<a>` that acts as a button (it has no href): announces it as a button, puts it in the tab order and
 * lets Enter and Space activate it like a click does.
 */
export function buttonLinkProps(onActivate: () => void) {
  return {
    role: 'button' as const,
    tabIndex: 0,
    onClick: onActivate,
    onKeyDown: (event: KeyboardEvent<HTMLElement>) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        onActivate();
      }
    },
  };
}
